 export const BaseImageUrl = "http://localhost/owners_portal/public/"